module.exports = __webpack_public_path__ + "static/media/CornellCover.612982b6.png";